
import React from 'react';

export const TrustMarquee: React.FC = () => {
  const items = [
    "GDPR COMPLIANT", "ISO 27001 STANDARDS", "MICROSOFT AZURE", 
    "HOSTED IN AUSTRIA", "OPEN SOURCE AI", "PYTHON", 
    "LANGCHAIN", "PINECONE", "NVIDIA INCEPTION"
  ];

  const marqueeContent = [...items, ...items, ...items, ...items];

  return (
    <div className="w-full py-12 overflow-hidden relative bg-white">
      <div className="absolute left-0 top-0 bottom-0 w-40 bg-gradient-to-r from-white to-transparent z-10" />
      <div className="absolute right-0 top-0 bottom-0 w-40 bg-gradient-to-l from-white to-transparent z-10" />
      
      <div className="flex whitespace-nowrap animate-marquee hover:[animation-play-state:paused] opacity-40 hover:opacity-100 transition-opacity duration-500">
        {marqueeContent.map((item, index) => (
          <div key={index} className="mx-12 flex items-center gap-4 select-none">
             <span className="text-xs font-bold tracking-[0.2em] text-gray-900 uppercase font-mono">
               {item}
             </span>
          </div>
        ))}
      </div>
    </div>
  );
};
